export default __webpack_public_path__ + "static/media/lost.69d30258.mp3";